'use strict';

import GLightbox from 'glightbox'

const SELECTOR = 'js-inline-modal';

export function init() {
    const element = document.querySelector('.' + SELECTOR);

    if (element === null) {
        return false;
    }

    GLightbox({
        selector: SELECTOR,
        height: "auto",
        draggable: false
    });
}

export default { init }
